class SnsShare {
  constructor() {
    this.event();
  }

  event() {
    document.querySelectorAll('.js-sns-share').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const url = btn.dataset.shareUrl;
        const title = btn.dataset.shareTitle;

        if (!url) {
          return;
        }

        if (navigator.share) {
          try {
            await navigator.share({ title, url });
          } catch (err) {
            if (err.name !== 'AbortError') {
              this.copyUrl(url);
            }
          }
          return;
        }

        this.copyUrl(url);
      });
    });
  }

  copyUrl(url) {
    if (!navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(url).catch(() => {});
  }
}
